// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderList_pageWrap__ufEJZ {
  padding: 4px 4px 32px;
}

/* =========================================================
   Toolbar
   ========================================================= */
.OrderList_toolbarRow__\\+GDJ7 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.OrderList_searchInput__EPq2a {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  flex: 1 1 160px;
  min-width: 140px;
}
.OrderList_searchInput__EPq2a:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.OrderList_sellerSelect__0bbMV {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  flex: 0 1 220px;
  min-width: 160px;
  max-width: 240px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.OrderList_sellerSelect__0bbMV:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.OrderList_servicesWrap__E-V1n {
  position: relative;
}

.OrderList_servicesBtn__wZfuZ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 700;
  padding: 10px 20px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}
.OrderList_servicesBtn__wZfuZ:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);
}

.OrderList_servicesDropdown__-1-Ys {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #E7E9F1;
  border-radius: 14px;
  box-shadow: 0 20px 44px rgba(27, 37, 89, 0.16);
  padding: 14px;
  min-width: 220px;
}

.OrderList_dropdownBtn__Oyp1k {
  display: block;
  width: 100%;
  text-align: left;
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 14px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.OrderList_dropdownBtn__Oyp1k:hover {
  background: #E7DEFB;
}

.OrderList_dropdownBtnPrimary__EfFXA {
  display: block;
  width: 100%;
  text-align: left;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 14px;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(76, 47, 179, 0.22);
  transition: transform 0.15s ease;
}
.OrderList_dropdownBtnPrimary__EfFXA:hover {
  transform: translateY(-1px);
}

.OrderList_exportModal__\\+AFIM {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(480px, calc(100vw - 32px));
  padding: 0;
  border: 1px solid #ebe8f4;
  border-radius: 16px;
  outline: none;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(32, 20, 72, 0.28);
  overflow: visible;
}

.OrderList_orderUpdateModal__i5kk2 {
  width: min(560px, calc(100vw - 32px));
}

.OrderList_exportModalHeader__BlnYq {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #efedf5;
}

.OrderList_exportModalTitle__ymqb6 {
  margin: 0;
  color: #291b59;
  font-size: 20px;
  font-weight: 700;
}

.OrderList_exportModalSubtitle__O6Zd1 {
  margin: 6px 0 0;
  color: #737087;
  font-size: 13px;
}

.OrderList_exportModalClose__bAYgT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border: 0;
  border-radius: 9px;
  background: #f5f3fa;
  color: #57459a;
  cursor: pointer;
}

.OrderList_exportModalClose__bAYgT:hover {
  background: #ece7fa;
}

.OrderList_exportModalBody__W4nrm {
  padding: 22px 24px 18px;
}

.OrderList_exportDateGrid__jvYuS {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.OrderList_exportDateField__uE0Lh {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}

.OrderList_exportDateField__uE0Lh label {
  color: #39334f;
  font-size: 13px;
  font-weight: 600;
}

.OrderList_exportDateField__uE0Lh .react-datepicker-wrapper,
.OrderList_exportDateField__uE0Lh .react-datepicker__input-container {
  display: block;
  width: 100%;
}

.OrderList_exportDateInput__3V9H4 {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding: 0 12px;
  border: 1px solid #dcd9e7;
  border-radius: 9px;
  background: #ffffff;
  color: #29243c;
  font-size: 14px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.OrderList_exportDateInput__3V9H4:focus {
  border-color: #6548c8;
  outline: none;
  box-shadow: 0 0 0 3px rgba(101, 72, 200, 0.14);
}

.OrderList_exportDatePopper__-0w3O {
  z-index: 1500 !important;
}

.OrderList_exportDateError__KCJcX {
  margin: 14px 0 0;
  color: #b42318;
  font-size: 13px;
}

.OrderList_exportDateHint__rhP4L {
  margin: 14px 0 0;
  color: #777387;
  font-size: 12px;
}

.OrderList_exportModalFooter__\\+t-m1 {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 20px;
  border-top: 1px solid #efedf5;
  background: #fbfaff;
  border-radius: 0 0 16px 16px;
}

.OrderList_orderUpdateBody__9eg6J {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 22px 24px;
}

.OrderList_orderUpdateGrid__ukILB {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.OrderList_orderUpdateField__I8I4q {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}

.OrderList_orderUpdateField__I8I4q label {
  color: #39334f;
  font-size: 13px;
  font-weight: 600;
}

.OrderList_orderUpdateField__I8I4q input,
.OrderList_orderUpdateField__I8I4q select {
  box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid #dcd9e7;
  border-radius: 9px;
  background: #ffffff;
  color: #29243c;
  font-size: 14px;
}

.OrderList_orderUpdateField__I8I4q input:focus,
.OrderList_orderUpdateField__I8I4q select:focus {
  border-color: #6548c8;
  outline: none;
  box-shadow: 0 0 0 3px rgba(101, 72, 200, 0.14);
}

.OrderList_cancelledOrderNotice__nOna2 {
  padding: 12px 14px;
  border: 1px solid #f2d4d4;
  border-radius: 9px;
  background: #fff7f7;
  color: #9f3333;
  font-size: 13px;
}

.OrderList_exportCancelButton__XP\\+YU,
.OrderList_exportSubmitButton__PbK61 {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.OrderList_exportCancelButton__XP\\+YU {
  border: 1px solid #dedbe8;
  background: #ffffff;
  color: #514b64;
}

.OrderList_exportSubmitButton__PbK61 {
  border: 1px solid transparent;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  box-shadow: 0 5px 14px rgba(76, 47, 179, 0.2);
}

.OrderList_exportCancelButton__XP\\+YU:disabled,
.OrderList_exportSubmitButton__PbK61:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@media (max-width: 520px) {
  .OrderList_exportDateGrid__jvYuS {
    grid-template-columns: minmax(0, 1fr);
  }

  .OrderList_exportModalHeader__BlnYq,
  .OrderList_exportModalBody__W4nrm {
    padding-right: 18px;
    padding-left: 18px;
  }

  .OrderList_exportModalFooter__\\+t-m1 {
    padding-right: 18px;
    padding-left: 18px;
  }

  .OrderList_orderUpdateBody__9eg6J {
    padding-right: 18px;
    padding-left: 18px;
  }

  .OrderList_orderUpdateGrid__ukILB {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* =========================================================
   Table (raw <table>, not the shared .custom-table component)
   ========================================================= */
.OrderList_tableWrap__Ipw08 {
  overflow-x: auto;
}

.OrderList_premiumTable__NfzIw {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.OrderList_premiumTable__NfzIw thead th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ede9fb;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 11px;
  font-weight: 600;
  padding: 15px 18px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid #5b3fc8;
}

.OrderList_premiumTable__NfzIw tbody td {
  padding: 14px 18px;
  border-bottom: 1px solid #eef0f3;
  color: #1f2937;
  vertical-align: middle;
}

.OrderList_premiumTable__NfzIw tbody tr:hover td {
  background: #f8fafc;
}

.OrderList_premiumTable__NfzIw tbody tr:last-child td {
  border-bottom: none;
}

/* =========================================================
   Status pills
   ========================================================= */
.OrderList_pillBase__0qk7s {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.OrderList_pillGreen__KFdtu { background: #E9F9EF; color: #16A34A; }
.OrderList_pillBlue__Qczav { background: #EAF2FE; color: #3B82F6; }
.OrderList_pillAmber__G2CB9 { background: #FDEEDD; color: #F7941D; }
.OrderList_pillRed__i41eq { background: #FDEDED; color: #DC2626; }
.OrderList_pillGrey__tNt6r { background: #F3F4F6; color: #6B7280; }
.OrderList_pillViolet__-W3OX { background: #F5F3FE; color: #4c2fb3; }

.OrderList_trackLink__rEhaW {
  color: #4c2fb3;
  font-weight: 600;
  text-decoration: none;
}
.OrderList_trackLink__rEhaW:hover {
  text-decoration: underline;
}

/* =========================================================
   Pagination
   ========================================================= */
.OrderList_paginationBar__vQa9b {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 18px;
}

.OrderList_pageBtn__fnBn8 {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background: #ffffff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.OrderList_pageBtn__fnBn8:hover:not(:disabled) {
  background: #F5F3FE;
  border-color: #C9BCF2;
}
.OrderList_pageBtn__fnBn8:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.OrderList_pageBtnActive__OB0gF {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.OrderList_pageEllipsis__uTa5p {
  padding: 0 6px;
  color: #9CA3AF;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/orderlist/OrderList.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;EAC9C,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qCAAqC;EACrC,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,6DAA6D;EAC7D,cAAc;EACd,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;8DAE8D;AAC9D;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,8BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,6BAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,8BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,4BAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,6BAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,+BAAc,mBAAmB,EAAE,cAAc,EAAE;;AAEnD;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  flex: 1 1 160px;\n  min-width: 140px;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.sellerSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  flex: 0 1 220px;\n  min-width: 160px;\n  max-width: 240px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.sellerSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.servicesWrap {\n  position: relative;\n}\n\n.servicesBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13.5px;\n  font-weight: 700;\n  padding: 10px 20px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.servicesBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);\n}\n\n.servicesDropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #ffffff;\n  border: 1px solid #E7E9F1;\n  border-radius: 14px;\n  box-shadow: 0 20px 44px rgba(27, 37, 89, 0.16);\n  padding: 14px;\n  min-width: 220px;\n}\n\n.dropdownBtn {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 14px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n.dropdownBtn:hover {\n  background: #E7DEFB;\n}\n\n.dropdownBtnPrimary {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 14px;\n  cursor: pointer;\n  box-shadow: 0 6px 14px rgba(76, 47, 179, 0.22);\n  transition: transform 0.15s ease;\n}\n.dropdownBtnPrimary:hover {\n  transform: translateY(-1px);\n}\n\n.exportModal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(480px, calc(100vw - 32px));\n  padding: 0;\n  border: 1px solid #ebe8f4;\n  border-radius: 16px;\n  outline: none;\n  background: #ffffff;\n  box-shadow: 0 24px 70px rgba(32, 20, 72, 0.28);\n  overflow: visible;\n}\n\n.orderUpdateModal {\n  width: min(560px, calc(100vw - 32px));\n}\n\n.exportModalHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 24px 18px;\n  border-bottom: 1px solid #efedf5;\n}\n\n.exportModalTitle {\n  margin: 0;\n  color: #291b59;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.exportModalSubtitle {\n  margin: 6px 0 0;\n  color: #737087;\n  font-size: 13px;\n}\n\n.exportModalClose {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  border: 0;\n  border-radius: 9px;\n  background: #f5f3fa;\n  color: #57459a;\n  cursor: pointer;\n}\n\n.exportModalClose:hover {\n  background: #ece7fa;\n}\n\n.exportModalBody {\n  padding: 22px 24px 18px;\n}\n\n.exportDateGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.exportDateField {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.exportDateField label {\n  color: #39334f;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.exportDateField :global(.react-datepicker-wrapper),\n.exportDateField :global(.react-datepicker__input-container) {\n  display: block;\n  width: 100%;\n}\n\n.exportDateInput {\n  box-sizing: border-box;\n  width: 100%;\n  height: 44px;\n  padding: 0 12px;\n  border: 1px solid #dcd9e7;\n  border-radius: 9px;\n  background: #ffffff;\n  color: #29243c;\n  font-size: 14px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.exportDateInput:focus {\n  border-color: #6548c8;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(101, 72, 200, 0.14);\n}\n\n.exportDatePopper {\n  z-index: 1500 !important;\n}\n\n.exportDateError {\n  margin: 14px 0 0;\n  color: #b42318;\n  font-size: 13px;\n}\n\n.exportDateHint {\n  margin: 14px 0 0;\n  color: #777387;\n  font-size: 12px;\n}\n\n.exportModalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px 20px;\n  border-top: 1px solid #efedf5;\n  background: #fbfaff;\n  border-radius: 0 0 16px 16px;\n}\n\n.orderUpdateBody {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 22px 24px;\n}\n\n.orderUpdateGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.orderUpdateField {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.orderUpdateField label {\n  color: #39334f;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.orderUpdateField input,\n.orderUpdateField select {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 44px;\n  padding: 0 12px;\n  border: 1px solid #dcd9e7;\n  border-radius: 9px;\n  background: #ffffff;\n  color: #29243c;\n  font-size: 14px;\n}\n\n.orderUpdateField input:focus,\n.orderUpdateField select:focus {\n  border-color: #6548c8;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(101, 72, 200, 0.14);\n}\n\n.cancelledOrderNotice {\n  padding: 12px 14px;\n  border: 1px solid #f2d4d4;\n  border-radius: 9px;\n  background: #fff7f7;\n  color: #9f3333;\n  font-size: 13px;\n}\n\n.exportCancelButton,\n.exportSubmitButton {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.exportCancelButton {\n  border: 1px solid #dedbe8;\n  background: #ffffff;\n  color: #514b64;\n}\n\n.exportSubmitButton {\n  border: 1px solid transparent;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  box-shadow: 0 5px 14px rgba(76, 47, 179, 0.2);\n}\n\n.exportCancelButton:disabled,\n.exportSubmitButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n@media (max-width: 520px) {\n  .exportDateGrid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .exportModalHeader,\n  .exportModalBody {\n    padding-right: 18px;\n    padding-left: 18px;\n  }\n\n  .exportModalFooter {\n    padding-right: 18px;\n    padding-left: 18px;\n  }\n\n  .orderUpdateBody {\n    padding-right: 18px;\n    padding-left: 18px;\n  }\n\n  .orderUpdateGrid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* =========================================================\n   Table (raw <table>, not the shared .custom-table component)\n   ========================================================= */\n.tableWrap {\n  overflow-x: auto;\n}\n\n.premiumTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n}\n\n.premiumTable thead th {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ede9fb;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 15px 18px;\n  text-align: left;\n  white-space: nowrap;\n  border-bottom: 1px solid #5b3fc8;\n}\n\n.premiumTable tbody td {\n  padding: 14px 18px;\n  border-bottom: 1px solid #eef0f3;\n  color: #1f2937;\n  vertical-align: middle;\n}\n\n.premiumTable tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.premiumTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillBlue { background: #EAF2FE; color: #3B82F6; }\n.pillAmber { background: #FDEEDD; color: #F7941D; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillGrey { background: #F3F4F6; color: #6B7280; }\n.pillViolet { background: #F5F3FE; color: #4c2fb3; }\n\n.trackLink {\n  color: #4c2fb3;\n  font-weight: 600;\n  text-decoration: none;\n}\n.trackLink:hover {\n  text-decoration: underline;\n}\n\n/* =========================================================\n   Pagination\n   ========================================================= */\n.paginationBar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 18px;\n}\n\n.pageBtn {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  background: #ffffff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.pageBtn:hover:not(:disabled) {\n  background: #F5F3FE;\n  border-color: #C9BCF2;\n}\n.pageBtn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pageBtnActive {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: none;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pageEllipsis {\n  padding: 0 6px;\n  color: #9CA3AF;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `OrderList_pageWrap__ufEJZ`,
	"toolbarRow": `OrderList_toolbarRow__+GDJ7`,
	"searchInput": `OrderList_searchInput__EPq2a`,
	"sellerSelect": `OrderList_sellerSelect__0bbMV`,
	"servicesWrap": `OrderList_servicesWrap__E-V1n`,
	"servicesBtn": `OrderList_servicesBtn__wZfuZ`,
	"servicesDropdown": `OrderList_servicesDropdown__-1-Ys`,
	"dropdownBtn": `OrderList_dropdownBtn__Oyp1k`,
	"dropdownBtnPrimary": `OrderList_dropdownBtnPrimary__EfFXA`,
	"exportModal": `OrderList_exportModal__+AFIM`,
	"orderUpdateModal": `OrderList_orderUpdateModal__i5kk2`,
	"exportModalHeader": `OrderList_exportModalHeader__BlnYq`,
	"exportModalTitle": `OrderList_exportModalTitle__ymqb6`,
	"exportModalSubtitle": `OrderList_exportModalSubtitle__O6Zd1`,
	"exportModalClose": `OrderList_exportModalClose__bAYgT`,
	"exportModalBody": `OrderList_exportModalBody__W4nrm`,
	"exportDateGrid": `OrderList_exportDateGrid__jvYuS`,
	"exportDateField": `OrderList_exportDateField__uE0Lh`,
	"exportDateInput": `OrderList_exportDateInput__3V9H4`,
	"exportDatePopper": `OrderList_exportDatePopper__-0w3O`,
	"exportDateError": `OrderList_exportDateError__KCJcX`,
	"exportDateHint": `OrderList_exportDateHint__rhP4L`,
	"exportModalFooter": `OrderList_exportModalFooter__+t-m1`,
	"orderUpdateBody": `OrderList_orderUpdateBody__9eg6J`,
	"orderUpdateGrid": `OrderList_orderUpdateGrid__ukILB`,
	"orderUpdateField": `OrderList_orderUpdateField__I8I4q`,
	"cancelledOrderNotice": `OrderList_cancelledOrderNotice__nOna2`,
	"exportCancelButton": `OrderList_exportCancelButton__XP+YU`,
	"exportSubmitButton": `OrderList_exportSubmitButton__PbK61`,
	"tableWrap": `OrderList_tableWrap__Ipw08`,
	"premiumTable": `OrderList_premiumTable__NfzIw`,
	"pillBase": `OrderList_pillBase__0qk7s`,
	"pillGreen": `OrderList_pillGreen__KFdtu`,
	"pillBlue": `OrderList_pillBlue__Qczav`,
	"pillAmber": `OrderList_pillAmber__G2CB9`,
	"pillRed": `OrderList_pillRed__i41eq`,
	"pillGrey": `OrderList_pillGrey__tNt6r`,
	"pillViolet": `OrderList_pillViolet__-W3OX`,
	"trackLink": `OrderList_trackLink__rEhaW`,
	"paginationBar": `OrderList_paginationBar__vQa9b`,
	"pageBtn": `OrderList_pageBtn__fnBn8`,
	"pageBtnActive": `OrderList_pageBtnActive__OB0gF`,
	"pageEllipsis": `OrderList_pageEllipsis__uTa5p`
};
export default ___CSS_LOADER_EXPORT___;
